<div class="chart-container">
    <ngx-charts-bar-vertical [legendTitle]="legendTitle" [scheme]="dashTema" [results]="results" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel" (select)="onSelect($event)" style="fill: grey;">
    </ngx-charts-bar-vertical>
</div>